import { createApiClient } from "#/shared/api/client";

/** Creates auxiliary coordinate/pin-info reads using resolved finder endpoints and embed base URL. */
export function createMapPinsApi({
  coordinatesUrl,
  pinInfoUrl,
  baseURL,
  client = createApiClient({ baseURL, parse: false }),
}) {
  function coordinates(params, { signal } = {}) {
    return client.request("get", coordinatesUrl, { params, signal });
  }
  function pinInfo(addressId, { signal } = {}) {
    return client.request("get", pinInfoUrl, { params: { address_id: addressId }, signal });
  }
  return Object.freeze({ coordinates, pinInfo });
}
